import { Reveal } from "@/components/site/Motion";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { LinkButton } from "@/components/site/LinkButton";
import { CoachingScope } from "@/components/site/CoachingScope";

export const HomeInvitation = () => (
  <section className="px-5 pb-20 pt-8 sm:px-8 md:pb-28 md:pt-12 lg:px-12" data-testid="home-closing">
    <Reveal className="relative mx-auto max-w-6xl overflow-hidden rounded-[2rem] border border-[#d7bd8d]/60 bg-[#f2ebe0]">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_85%_45%,rgba(212,166,74,0.25),transparent_65%)]"
      />
      <div className="relative grid items-center gap-10 px-7 py-12 sm:px-12 sm:py-16 md:grid-cols-[1.3fr_0.7fr] md:gap-12 lg:px-16 lg:py-20">
        <div>
          <p className="eyebrow text-center sm:text-left">Begin with Panchmaya</p>
          <h2 className="font-display mt-5 text-center text-[2.75rem] leading-[1.08] tracking-tight text-[#221e1b] sm:text-left sm:text-6xl lg:text-[4.25rem]">
            Make space<br />
            <em className="text-[#7a5615]">for yourself.</em>
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-[#5d544c] sm:text-lg">
            Ready to begin? Connect with Sheetal directly on WhatsApp to book a private 1:1 coaching
            discovery call, or inquire about the upcoming 21-day journey.
          </p>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-x-7 gap-y-5 sm:justify-start">
            <WhatsAppButton testId="home-closing-whatsapp-btn" />
            <LinkButton to="/journey" variant="text" testId="home-closing-journey-btn">
              Explore the Journey
            </LinkButton>
          </div>
          <CoachingScope />
        </div>
        <div aria-hidden="true" className="hidden flex-col items-center md:flex">
          <div className="relative flex aspect-square w-full max-w-[280px] items-center justify-center">
            <div className="absolute inset-0 rounded-full border border-[#a8792a]/25" />
            <div className="absolute inset-5 rounded-full border border-[#a8792a]/15" />
            <img
              src="/panchmaya-mark-320.webp"
              srcSet="/panchmaya-mark-320.webp 320w, /panchmaya-mark-640.webp 640w"
              sizes="202px"
              width="320"
              height="320"
              loading="lazy"
              alt=""
              className="relative h-auto w-[72%] rounded-full shadow-[0_16px_48px_rgba(122,86,21,0.12)]"
            />
          </div>
          <p className="font-display mt-7 text-center text-2xl italic text-[#7a5615]">
            From darkness to light
          </p>
        </div>
      </div>
    </Reveal>
  </section>
);
